/** IIT Hyderabad Hospital brand tokens & fallback copy for the public site. */

export const IITH = {
  saffron: '#F15A22',
  navy: '#071B34',
  navyMid: '#0C2744',
  ink: '#040E1A',
  mist: '#E8EEF5',
  mute: '#9AADBE',
  gold: '#C4A35A',
  institute: 'Indian Institute of Technology Hyderabad',
  hospital: 'IIT Hyderabad Hospital',
  campus: 'Kandi, Sangareddy · Telangana 502285',
  tagline: 'Innovating and Inventing in Technology for Humanity',
  headline: 'Campus healthcare, delivered with precision.',
  support:
    'Official medical centre for students, faculty, staff and families — book OPD slots with IITH doctors online.',
  about: [
    'IIT Hyderabad Hospital provides primary care, specialist consultations and campus health services for the IITH community.',
    'Our medical officers, visiting consultants and physiotherapy team work together so you can get the right care without leaving campus.',
  ],
  highlights: [
    'OPD booking by specialty — medical officers & visiting consultants',
    'Pediatrics, ENT, dermatology, orthopedics, ophthalmology and more',
    'Digital records and confidential campus care',
    'Aligned with IITH’s mission of technology for humanity',
  ],
};

export const SERIF = '"Source Serif 4", "Libre Baskerville", Georgia, serif';
export const SANS = 'Manrope, "IBM Plex Sans", system-ui, sans-serif';

export function heroBackground(primary, heroImage) {
  if (heroImage) {
    return {
      backgroundImage:
        `linear-gradient(105deg, rgba(7,27,52,0.94) 0%, rgba(7,27,52,0.72) 55%, rgba(7,27,52,0.55) 100%),` +
        ` url("${heroImage}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  }
  return {
    background:
      `radial-gradient(ellipse 80% 60% at 85% 20%, ${primary}33 0%, transparent 55%),` +
      ` radial-gradient(ellipse 50% 40% at 10% 90%, ${IITH.gold}18 0%, transparent 50%),` +
      ` linear-gradient(165deg, ${IITH.ink} 0%, ${IITH.navy} 45%, ${IITH.navyMid} 100%)`,
  };
}
